// Configuration commerciale — à compléter avant la mise en ligne.
// Tant que checkoutUrl est vide, les boutons d'achat restent désactivés.
export const offer = {
  brand: "Petites Histoires, Grande Foi",
  productName: "Le Méga Pack de Paraboles Chrétiennes",
  price: "19,90 €",
  checkoutUrl: "",
  supportEmail: "",
};

// Identité visuelle officielle (fichiers fournis par la marque).
export const brandAssets = {
  logo: "https://cdn.magicpatterns.com/uploads/h5TK7LVVQYRurwn6qr7mjh/Pequenas_historias,_gran_fe.png",
  tagline: "Des histoires qui font grandir les petits cœurs.",
  // Planche de pages réelles du Méga Pack (capture fournie).
  pageSheet: {
    src: "https://cdn.magicpatterns.com/uploads/ejrjbSq8EGUea5BYaZdbAD/image.png",
    width: 1817,
    cardWidth: 224,
    cardHeight: 319,
    top: 25,
  },
};

// Mockups finaux — collez l'URL d'une image pour remplacer la composition de pages.
export const productVisuals = {
  heroMockup: "",
  offerMockup: "",
};

export const lifestylePhotos = {
  readingTogether:
    "https://cdn.magicpatterns.com/patterns/generated-images/98e77a23-296e-467c-ad7b-227bc1c69c55.jpg",
};
